/**
 * AI Events API — fetch paginated AI provider events from the backend.
 */

import axiosInstance from './axios';

export interface AIEventRecord {
  id: number;
  org_id: string;
  provider: string;
  event_type: string;
  severity: 'error' | 'warning' | 'info';
  api_endpoint?: string;
  http_status?: number;
  error_message?: string;
  metadata?: Record<string, unknown>;
  created_at: string;
}

export interface FetchAIEventsParams {
  provider?: string;
  severity?: string;
  hours?: number;
  page?: number;
  page_size?: number;
}

export interface FetchAIEventsResponse {
  events: AIEventRecord[];
  total: number;
  page: number;
  page_size: number;
}

export async function fetchAIEvents(
  params: FetchAIEventsParams = {}
): Promise<FetchAIEventsResponse> {
  const query: Record<string, string | number> = {};
  if (params.provider) query.provider = params.provider;
  if (params.severity) query.severity = params.severity;
  if (params.hours) query.hours = params.hours;
  if (params.page) query.page = params.page;
  if (params.page_size) query.page_size = params.page_size;

  const response = await axiosInstance.get<FetchAIEventsResponse>('/api/ai-events', {
    params: query,
  });
  return response.data;
}
